import { render, staticRenderFns } from "./TradingAccountFormModal.vue?vue&type=template&id=207efc9d"
import script from "./TradingAccountFormModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./TradingAccountFormModal.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('207efc9d')) {
      api.createRecord('207efc9d', component.options)
    } else {
      api.reload('207efc9d', component.options)
    }
    module.hot.accept("./TradingAccountFormModal.vue?vue&type=template&id=207efc9d", function () {
      api.rerender('207efc9d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Modals/TradingAccountFormModal.vue"
export default component.exports